import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

import { transformSource } from '../../utils/helpers';
import './BrandMaterials.sass';

import BrandMaterial from '../../uikit/BrandMaterial';

interface Props {
	brands: [];
	sectionTitle: string;
	legalNotice: string;
}

function BrandMaterials(props: Props) {
	const { brands, sectionTitle, legalNotice } = props;
	return (
		<section className="brand-materials">
			<Container>
				<Row>
					<Col xs={12} className="brand-materials__heading">
						<h2 className="uikit-label-small-caps">{sectionTitle}</h2>
					</Col>
					{brands.map((brand, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<Col xs={12} md={4} key={index} className="brand-materials__item">
							<BrandMaterial brand={brand} />
						</Col>
					))}
					<Col xs={12} className="brand-materials__legal">
						<p className="uikit-text-small">
							{ReactHtmlParser(legalNotice, {
								transform: transformSource,
							})}
						</p>
					</Col>
				</Row>
			</Container>
		</section>
	);
}

export default BrandMaterials;
